<template>
    <div>
        <el-row :gutter="5"> 
            <el-col :span="24">
                <el-row :gutter="5">
                    <el-col :span="3"><el-input v-model="sLoginName" style="width:100%" placeholder="账户名称"></el-input></el-col>
                    <el-col :span="3"><el-input v-model="sCustomerName" style="width:100%" placeholder="客户名称"></el-input></el-col>
                    <el-col :span="2"><el-button type="primary" icon="el-icon-search" style="width:100%"  @click="handleRefresh" >查询</el-button></el-col>
                    <el-col :span="2"><el-button type="primary" icon="el-icon-plus" style="width:100%" @click="handleAdd">新增</el-button></el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-table :data="Logins" max-height="600" v-loading="listLoading" ref="singleTable" border 
       header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;" >
             <el-table-column label="删除" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column label="编辑" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column prop="LoginName" label="帐户名称"  width="200"></el-table-column>
            <el-table-column prop="CustomerName" label="客户"  width="200"></el-table-column>
            <el-table-column prop="SuspendDesc" label="失效" width="100"></el-table-column>
        </el-table>
        <el-col  :span="24">
            <el-pagination small
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="recordtotal">
            </el-pagination>
        </el-col>

        <el-dialog title="编辑" :visible.sync="editFormVisible" >
            <el-form :model="editForm">
                <el-form-item label="帐户名称" :label-width="formLabelWidth">
                    <el-input v-model="editForm.LoginName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Password" type="password" placeholder="密码" auto-complete="new-password"></el-input>
                </el-form-item>
                <el-form-item label="" :label-width="formLabelWidth">
                     <el-checkbox label="失效" v-model="editForm.bSuspend"></el-checkbox>
                </el-form-item>
                <el-form-item label="客户" :label-width="formLabelWidth">
                    <el-select v-model="editForm.CustomerId" placeholder="客户" clearable filterable>
                        <el-option v-for="customer in customers" :key="customer.Id" :label="customer.Desc" :value="customer.Id" >{{customer.Desc}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="微信号：" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Wechat" auto-complete="off"></el-input>(可多个，用分号分隔)
                </el-form-item>

                <el-form-item label="角色" :label-width="formLabelWidth">
                    <el-radio-group v-model="editForm.RoleId">
                      <el-radio v-for="role in roles" :key="role.Id" :label="role.Id" :value="role.Id">{{role.Name}}</el-radio>
                    </el-radio-group>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleUpdate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MaintainLoginJs from "./MaintainLogin.js";

    export default MaintainLoginJs;
</script>


<style >
    .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  
</style>


// WEBPACK FOOTER //
// src/components/MaintainLogin/MaintainLogin.vue